"use client";

import type { AstroEngine } from "@kedaat/engine";
import { useEffect, useState } from "react";
import type { CalendarModule } from "./zmanim";

export interface LoadedEngine {
  astro: AstroEngine;
  calendar: CalendarModule;
}

/** Loads the LGPL calculation library as a separate chunk (see docs/LICENSING.md). */
export function useEngine(): LoadedEngine | null {
  const [engine, setEngine] = useState<LoadedEngine | null>(null);
  useEffect(() => {
    let cancelled = false;
    Promise.all([import("@kedaat/engine/kosher"), import("@kedaat/engine/calendar")]).then(
      ([kosher, calendar]) => {
        if (!cancelled) setEngine({ astro: new kosher.KosherZmanimAstro(), calendar });
      },
    );
    return () => {
      cancelled = true;
    };
  }, []);
  return engine;
}

/** The current time, refreshed periodically. Null until mounted, to avoid hydration mismatches. */
export function useNow(intervalMs = 30_000): number | null {
  const [now, setNow] = useState<number | null>(null);
  useEffect(() => {
    setNow(Date.now());
    const id = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(id);
  }, [intervalMs]);
  return now;
}
